<template>
    <div class="rounded-md shadow-2xs">
        <Select
            :model-value="horseId"
            @update:model-value="emits('update:horseId', $event)"
            name="Horse"
            :label="$t('horse.title')"
            :disabled="disabled"
            :empty-option-label="emptyOptionLabel"
        >
            <option v-for="horse in horses" :key="horse.id" :value="horse.id">
                {{ horse.name }}
            </option>
        </Select>
    </div>

    <div class="rounded-md shadow-2xs">
        <Select
            :model-value="riderId"
            @update:model-value="emits('update:riderId', $event)"
            name="Rider"
            :label="$t('user.rider')"
            :disabled="disabled"
            :empty-option-label="emptyOptionLabel"
        >
            <option v-for="rider in riders" :key="rider.id" :value="rider.id">
                {{ rider.first_name }} {{ rider.last_name }}
            </option>
        </Select>
    </div>

    <div class="rounded-md shadow-2xs">
        <Select
            :model-value="discipline"
            @update:model-value="emits('update:discipline', $event)"
            name="Discipline"
            :label="$t('session.discipline.title')"
            :disabled="disabled"
            :empty-option-label="emptyOptionLabel"
        >
            <option v-for="disciplineOption in disciplineOptions" :key="disciplineOption.value" :value="disciplineOption.value">
                {{ disciplineOption.label }}
            </option>
        </Select>
    </div>
</template>

<script setup>
import Select from '@/components/form/Select.vue'

defineProps({
    horseId: { type: [String, Number], default: '' },
    riderId: { type: [String, Number], default: '' },
    discipline: { type: [String, Number], default: '' },
    horses: { type: Array, default: () => [] },
    riders: { type: Array, default: () => [] },
    disciplineOptions: { type: Array, default: () => [] },
    emptyOptionLabel: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
})

const emits = defineEmits(['update:horseId', 'update:riderId', 'update:discipline'])
</script>
